import { FunctionComponent } from 'react'
import Icon from 'components/shared/Icon'

const NotFound: FunctionComponent<NotFoundProps> = ({ message = 'Page not found' }: NotFoundProps) => (
  <div className='pv12 lite-grey flex flex-column items-center f3'>
    <span className='w7'><Icon name='icon-alert' className='w7' /></span>
    <span className='mt6'>{message}</span>
  </div>
)

interface NotFoundProps {
  message: string
}

export default NotFound
